import axios from 'axios'
import auth from '@/plugins/api/users/auth'
import logoutOnUnauthorized from "../logout";
const ENDPOINT_PILL = auth.api.endpointPath + 'pills'
const ENDPOINT_ASSIGNED_PILLS = auth.api.endpointPath + 'assigned_pills'
const ENDPOINT_WISHLIST = auth.api.endpointPath + 'wishlists'
const ENDPOINT_CATEGORIES = auth.api.endpointPath + 'o/get-categories'
const pillList = null
export default {
  getPendingPills(){
      const token = sessionStorage.getItem('token')
      axios.defaults.headers.common.Authorization = 'Bearer ' + token
      const id = sessionStorage.getItem('user_id')
      const params = {
        'pillpackPlay.user.id': id,
        'order[startDate]': 'asc',
        'startDate[before]': new Date(),
        'done': false,
        'expired': false,
      };
      return axios.get(ENDPOINT_ASSIGNED_PILLS, { params: params }).catch(logoutOnUnauthorized)
  },
  getCompletedPills(){
      const token = sessionStorage.getItem('token')
      axios.defaults.headers.common.Authorization = 'Bearer ' + token
      const id = sessionStorage.getItem('user_id')
      const params = {
          'pillpackPlay.user.id': id,
          'order[startDate]': 'desc',
          'startDate[before]': new Date(),
          'done': true,
          'expired': false,
      };
      return axios.get(ENDPOINT_ASSIGNED_PILLS, { params: params }).catch(logoutOnUnauthorized)
  },
    getFavoritePills(){
        const token = sessionStorage.getItem('token')
        axios.defaults.headers.common.Authorization = 'Bearer ' + token
        const id = sessionStorage.getItem('user_id')
        const params = {
            'user.id': id,
        };
        return axios.get(ENDPOINT_WISHLIST, { params: params }).catch(logoutOnUnauthorized)
    },
  getPills () {
    const token = sessionStorage.getItem('token')
    axios.defaults.headers.common.Authorization = 'Bearer ' + token
    return axios.get(ENDPOINT_PILL).catch(logoutOnUnauthorized)
  },
  getPillById (id) {
      const token = sessionStorage.getItem('token')
      axios.defaults.headers.common.Authorization = 'Bearer ' + token
      return axios.get(ENDPOINT_PILL+'/'+id)
        .then((res) => {
          return res.data
        }).catch(logoutOnUnauthorized)
  },
    getCategories() {
        const token = sessionStorage.getItem('token')
        axios.defaults.headers.common.Authorization = 'Bearer ' + token
        return axios.get(ENDPOINT_CATEGORIES).catch(logoutOnUnauthorized)
    }
}
